import React from "react";
import Edit, { type Columns } from "../../component/Edit";
import useLocale from "../../util/i18n";
import { useCrumbs } from "../../component/breadcrumbs";
import Toast from "../../component/toast";
import currencies from "../../util/currencies.json";
import { getSupplier, saveSupplier } from "../../api/erp";
import { useNavigate } from "react-router-dom";

export default function Config() {
    const { 0: __ } = useLocale();
    const { 0: setCrumbs } = useCrumbs();
    let navigate = useNavigate();
    let columns = React.useMemo<Columns>(() => ({
        [__('General')]: [
            {
                name: 'id',
                type: 'hidden'
            },
            {
                label: 'ID',
                name: 'code',
                required: true
            },
            {
                label: __('Name'),
                name: 'name',
                required: true
            },
            {
                label: __('Email'),
                name: 'email',
                type: 'email'
            },
            {
                label: __('Currency'),
                name: 'currency',
                required: true,
                default: 'USD',
                type: 'select',
                options: currencies.map(value => ({ value, label: __(value) }))
            },
            {
                label: __('Tax Rate'),
                name: 'tax_rate',
                type: 'number',
                default: '0',
                required: true
            },
            {
                label: __('Note'),
                name: 'note',
                type: 'textarea'
            }
        ]
    }), [__]);
    const doLoad = React.useCallback((data: any) => {
        return getSupplier(data);
    }, []);
    const doSave = React.useCallback((data: FormData) => {
        saveSupplier(data).then(response => {
            if (typeof response !== 'string') {
                if (response.data) {
                    navigate('/supplier/edit?id=' + response.data, { replace: true });
                }
                Toast.show(response.msg);
            } else {
                Toast.show(response);
            }
        }, () => Toast.show(__('An error detected. Please try again later.')));
    }, [__]);
    React.useEffect(() => {
        setCrumbs([{ label: 'Supplier', link: '/supplier' }, 'Edit']);
    }, []);
    return (
        <Edit columns={columns} doLoad={doLoad} doSave={doSave} />
    );
}